import React from 'react';
import Helmet from 'react-helmet';
import '../stylesheets/core.less';
import '../stylesheets/pages/NotFound.less';
import { MinimalFooter } from '@zola/zola-ui';
import CustomSearchInputField from '../components/common/ui/CustomSearchInputField';

import Cake from '../assets/images/404/404-cake.svg';
import Heart from '../assets/images/404/Heart.svg';

export default function NotFoundv2() {
  return (
    <div className="not-found-page">
      <Helmet
        style={[
          {
            type: 'text/css',
            cssText: ` html, .main-content {
              background: #FCFCFC;
            }
            body {
              margin-bottom: 75px;
            }`
          }
        ]}
      />
      <header className="minimal-header">
        <a href="/" target="_self">
          <div className="zola-logo-horizontal-black center-block" />
        </a>
      </header>
      <div className="container">
        <div className="row not-found-page-content center-block">
          <img src={Cake} alt="404 Page Not Found" className="hidden-xs" />
          <div className="not-found-page-actions">
            <h1 className=""><span className="script">Uh oh!</span><br className="visible-xs" /> This page doesn&apos;t exist.</h1>
            <a className="v2-button secondary-button" href="/">Go to Zola Home</a>
            <div className="pagebreak" />
            <img src={Heart} alt="404 Page Not Found" className="visible-xs center-block" />
            <h1 className="">Find a <span className="underline">Zola Couple</span></h1>
            <form action="/search/wedding-registry">
              <CustomSearchInputField placeholder="Search by First/Last Names" />
              <button className="v2-button primary-button notFound__button--search" type="submit" onSubmit="/search/wedding-registry">Search</button>
            </form>
          </div>
        </div>
      </div>
      <MinimalFooter />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/NotFoundv2.jsx